import ProdDetail from './ProdDetail';
import PreProdDetail from './PreProdDetail';
import useDetail from '../../application/bloc/useDetail';

const Detail = () => {
  const { hasRequestSeq } = useDetail();
  return hasRequestSeq ? <ProdDetail /> : <PreProdDetail />;
};

export default Detail;
